/**
 * 日志管理模块，
 * 代替console.log，避免各页面中到处打印console.log，在release版本中会比较乱
 */

const Config = {
  debug: /(&\|\?)debug=true/.test(window.location.search) || true,
  log: true,
  error: true,
};

window.console.setLog = (sType, bValue) => {
  Config[sType] = bValue;
};

function showMsg(isShow, ...msg) {
  isShow && console.log(new Date().toLocaleString(), ...msg);
}
function MyLog(sModuleName) {
  return {
    debug: (...msg) => {
      // 调试信息，在发布版本中会被关闭
      showMsg(Config.debug, sModuleName, ...msg);
    },
    log: (...msg) => {
      // 一般性信息
      showMsg(Config.log, sModuleName, ...msg);
    },
    error: (...msg) => {
      // 错误信息在不强制关闭的情况下都要显示
      showMsg(Config.error !== false, sModuleName, ...msg);
    },
  };
}

export default MyLog;
